export default function Message(props){
    return(
        <div className="page"><div className='fs-2 text-white'>{props.content}</div></div>
    );
}